import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icon-league.png'
import _imports_1 from '@/assets/img/icon-tournament.png'


const _withScopeId = n => (_pushScopeId("data-v-39860501"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "season-group-wrapper" }
const _hoisted_2 = { class: "layout-inner -top-and-bottom" }
const _hoisted_3 = { class: "season-group-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "global-add-icon" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "新しいリーグを追加", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "global-loading"
}
const _hoisted_8 = { class: "item" }
const _hoisted_9 = { class: "custom-list-card" }
const _hoisted_10 = { class: "custom-list-card-header" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "draggableButton" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "global-icon-button"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "uil uil-draggabledots icon" })
  ])
], -1))
const _hoisted_12 = ["onUpdate:modelValue", "onChange"]
const _hoisted_13 = { class: "global-select -with-icon" }
const _hoisted_14 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "icon"
}
const _hoisted_15 = {
  key: 1,
  src: _imports_1,
  alt: "",
  class: "icon"
}
const _hoisted_16 = ["onUpdate:modelValue", "onChange"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 1 }, "リーグ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 2 }, "トーナメント", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "global-select" }
const _hoisted_21 = ["onUpdate:modelValue", "onChange"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: undefined,
  disabled: ""
}, "会場グループを選択", -1))
const _hoisted_23 = ["value"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "content" }
const _hoisted_28 = { class: "item" }
const _hoisted_29 = { class: "group-list-card" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "draggableButton" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "global-icon-button"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "uil uil-draggabledots icon" })
  ])
], -1))
const _hoisted_31 = ["onUpdate:modelValue", "onChange"]
const _hoisted_32 = ["onUpdate:modelValue", "onChange"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, null, -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 1,
  class: "group-list"
}
const _hoisted_37 = { class: "group-list-card" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "draggableButton" }, null, -1))
const _hoisted_39 = ["onUpdate:modelValue", "onChange"]
const _hoisted_40 = ["onUpdate:modelValue", "onChange"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, null, -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = { class: "footer" }
const _hoisted_45 = ["disabled", "onClick"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "global-add-icon" }, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "新しいブロックを追加", -1))
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = { class: "custom-list" }
const _hoisted_50 = { class: "custom-list-card" }
const _hoisted_51 = { class: "custom-list-card-header" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "draggableButton" }, null, -1))
const _hoisted_53 = ["onUpdate:modelValue", "onChange"]
const _hoisted_54 = { class: "global-select -with-icon" }
const _hoisted_55 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "icon"
}
const _hoisted_56 = {
  key: 1,
  src: _imports_1,
  alt: "",
  class: "icon"
}
const _hoisted_57 = ["onUpdate:modelValue", "onChange"]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 1 }, "リーグ", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: 2 }, "トーナメント", -1))
const _hoisted_60 = [
  _hoisted_58,
  _hoisted_59
]
const _hoisted_61 = { class: "global-select" }
const _hoisted_62 = ["onUpdate:modelValue", "onChange"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: undefined,
  disabled: ""
}, "会場グループを選択", -1))
const _hoisted_64 = ["value"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, null, -1))
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "global-add-button -only-text -round",
    disabled: "true"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "global-add-icon" }),
    /*#__PURE__*/_createElementVNode("span", { class: "text" }, "新しいブロックを追加")
  ])
], -1))
const _hoisted_69 = {
  key: 2,
  class: "global-empty-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseBreadcrumb = _resolveComponent("BaseBreadcrumb")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_BaseDialog = _resolveComponent("BaseDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BaseBreadcrumb, { breadcrumbs: _ctx.breadcrumbs }, null, 8, ["breadcrumbs"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "global-add-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addCustomBlock()))
          }, _hoisted_6),
          (_ctx.groups.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7))
            : (_ctx.groups.list.length > 0 || _ctx.groups.newCustoms.length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_draggable, {
                    tag: "ul",
                    class: "custom-list",
                    list: _ctx.groups.list,
                    handle: ".custom-list-card-header .global-icon-button",
                    "item-key": "temporary_id",
                    onUpdate: _ctx.updateCustomPriority
                  }, {
                    item: _withCtx(({element, index}) => [
                      _createElementVNode("li", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _hoisted_11,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "global-input",
                              "onUpdate:modelValue": ($event: any) => ((element.name) = $event),
                              onChange: ($event: any) => (_ctx.updateCustom(element))
                            }, null, 40, _hoisted_12), [
                              [_vModelText, element.name]
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              (element.match_type_id === 1)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                                : (element.match_type_id === 2)
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                                  : _createCommentVNode("", true),
                              _withDirectives(_createElementVNode("select", {
                                class: "select",
                                "onUpdate:modelValue": ($event: any) => ((element.match_type_id) = $event),
                                onChange: ($event: any) => (_ctx.updateCustom(element))
                              }, _hoisted_19, 40, _hoisted_16), [
                                [_vModelSelect, element.match_type_id]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": ($event: any) => ((element.field_group_id) = $event),
                                class: "select",
                                onChange: ($event: any) => (_ctx.updateCustom(element))
                              }, [
                                _hoisted_22,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fieldGroups.list, (field) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: field.id,
                                    value: field.id
                                  }, _toDisplayString(field.name), 9, _hoisted_23))
                                }), 128))
                              ], 40, _hoisted_21), [
                                [_vModelSelect, element.field_group_id]
                              ])
                            ]),
                            _createElementVNode("button", {
                              class: "global-delete-button",
                              onClick: ($event: any) => (_ctx.openCustomDialogDelete(element))
                            }, _hoisted_26, 8, _hoisted_24)
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            (element.groups.length > 0)
                              ? (_openBlock(), _createBlock(_component_draggable, {
                                  key: 0,
                                  tag: "ul",
                                  class: "group-list",
                                  list: element.groups,
                                  handle: ".global-icon-button",
                                  "item-key": "temporary_id",
                                  onUpdate: ($event: any) => (_ctx.updateGroupPriority(element.groups))
                                }, {
                                  item: _withCtx(({element}) => [
                                    _createElementVNode("li", _hoisted_28, [
                                      _createElementVNode("div", _hoisted_29, [
                                        _hoisted_30,
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          class: "global-input",
                                          "onUpdate:modelValue": ($event: any) => ((element.group_code) = $event),
                                          onChange: ($event: any) => (_ctx.updateGroup(element))
                                        }, null, 40, _hoisted_31), [
                                          [_vModelText, element.group_code]
                                        ]),
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          class: "global-input",
                                          "onUpdate:modelValue": ($event: any) => ((element.name) = $event),
                                          onChange: ($event: any) => (_ctx.updateGroup(element))
                                        }, null, 40, _hoisted_32), [
                                          [_vModelText, element.name]
                                        ]),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "global-delete-button",
                                          onClick: ($event: any) => (_ctx.openGroupDialogDelete(element, index))
                                        }, _hoisted_35, 8, _hoisted_33)
                                      ])
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["list", "onUpdate"]))
                              : _createCommentVNode("", true),
                            (element.newGroups.length > 0)
                              ? (_openBlock(), _createElementBlock("ul", _hoisted_36, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.newGroups, (newGroup) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      class: "item",
                                      key: newGroup.temporary_id
                                    }, [
                                      _createElementVNode("div", _hoisted_37, [
                                        _hoisted_38,
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          class: "global-input",
                                          "onUpdate:modelValue": ($event: any) => ((newGroup.group_code) = $event),
                                          onChange: ($event: any) => (_ctx.addGroup(newGroup, element))
                                        }, null, 40, _hoisted_39), [
                                          [_vModelText, newGroup.group_code]
                                        ]),
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          class: "global-input",
                                          "onUpdate:modelValue": ($event: any) => ((newGroup.name) = $event),
                                          onChange: ($event: any) => (_ctx.addGroup(newGroup, element))
                                        }, null, 40, _hoisted_40), [
                                          [_vModelText, newGroup.name]
                                        ]),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "global-delete-button",
                                          onClick: ($event: any) => (_ctx.deleteNewGroup(newGroup, element))
                                        }, _hoisted_43, 8, _hoisted_41)
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "global-add-button -only-text -round",
                              disabled: element.id === undefined,
                              onClick: ($event: any) => (_ctx.addGroupRow(element))
                            }, _hoisted_48, 8, _hoisted_45)
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["list", "onUpdate"]),
                  _createElementVNode("ul", _hoisted_49, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups.newCustoms, (newCustom, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "item",
                        key: newCustom.temporary_id
                      }, [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _hoisted_52,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "global-input",
                              "onUpdate:modelValue": ($event: any) => ((newCustom.name) = $event),
                              ref: el => { if (el) _ctx.customNameInputs[index] = el },
                              onChange: ($event: any) => (_ctx.addCustom(newCustom))
                            }, null, 40, _hoisted_53), [
                              [_vModelText, newCustom.name]
                            ]),
                            _createElementVNode("div", _hoisted_54, [
                              (newCustom.match_type_id === 1)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_55))
                                : (newCustom.match_type_id === 2)
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_56))
                                  : _createCommentVNode("", true),
                              _withDirectives(_createElementVNode("select", {
                                class: "select",
                                "onUpdate:modelValue": ($event: any) => ((newCustom.match_type_id) = $event),
                                onChange: ($event: any) => (_ctx.addCustom(newCustom))
                              }, _hoisted_60, 40, _hoisted_57), [
                                [_vModelSelect, newCustom.match_type_id]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_61, [
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": ($event: any) => ((newCustom.field_group_id) = $event),
                                class: "select",
                                onChange: ($event: any) => (_ctx.addCustom(newCustom))
                              }, [
                                _hoisted_63,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fieldGroups.list, (field) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: field.id,
                                    value: field.id
                                  }, _toDisplayString(field.name), 9, _hoisted_64))
                                }), 128))
                              ], 40, _hoisted_62), [
                                [_vModelSelect, newCustom.field_group_id]
                              ])
                            ]),
                            _createElementVNode("button", {
                              class: "global-delete-button",
                              onClick: ($event: any) => (_ctx.deleteNewCustom(newCustom))
                            }, _hoisted_67, 8, _hoisted_65)
                          ]),
                          _hoisted_68
                        ])
                      ]))
                    }), 128))
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock("p", _hoisted_69, "登録されているリーグがありません"))
        ])
      ])
    ]),
    (_ctx.customDialogDelete.isOpen)
      ? (_openBlock(), _createBlock(_component_BaseDialog, {
          key: 0,
          dialog: _ctx.customDialogDelete,
          onCloseDialog: _ctx.closeCustomDialogDelete,
          onOnConfirm: _ctx.deleteCustom
        }, null, 8, ["dialog", "onCloseDialog", "onOnConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.groupDialogDelete.isOpen)
      ? (_openBlock(), _createBlock(_component_BaseDialog, {
          key: 1,
          dialog: _ctx.groupDialogDelete,
          onCloseDialog: _ctx.closeGroupDialogDelete,
          onOnConfirm: _ctx.deleteGroup
        }, null, 8, ["dialog", "onCloseDialog", "onOnConfirm"]))
      : _createCommentVNode("", true)
  ], 64))
}